import dailyTextsSaga, { fetchDailyTexts } from "./dailytexts";
import userSaga, { fetchUser } from "./user";
import timestampSaga from "./timestamp";
import mixpanelSaga from "./mixpanel";
import tutorialSaga from "./tutorial";

export function bootSagas(middleware) {
  middleware.run(userSaga);
  middleware.run(dailyTextsSaga);
  middleware.run(mixpanelSaga);
  middleware.run(tutorialSaga);
  if (process.env.NODE_ENV !== "development") {
    middleware.run(timestampSaga);
  }
}

export function bootStore({ dispatch }, { user_id }) {
  dispatch(fetchDailyTexts({ user_id }));
  dispatch(fetchUser({ user_id }));
}



// WEBPACK FOOTER //
// ./src/store/boot.js